import _activities from './activities';
import _calendarEvents from './calendar-events';
import _duties from './duties';
import _groups from './groups';
import _persons from './persons';
import _resources from './resources';
import _rooms from './rooms';
import _syllabuses from './syllabuses';

export default {
  activities:     _activities,
  calendarEvents: _calendarEvents,
  duties:         _duties,
  groups:         _groups,
  persons:        _persons,
  resources:      _resources,
  rooms:          _rooms,
  syllabuses:     _syllabuses,
};